import React from "react";
import BlogRepository from "../../repository/BlogRepository";
import StandardFormComponent from "../basics/form/StandardFormComponent";
import { withRouter } from 'react-router-dom';
import FormToastComponent from "../basics/FormToastComponent";
import FormHelper from "../../helpers/FormHelper";
import CheckPermissions from "../../helpers/CheckPermissions";
import UserRolesEnum from "../../enums/UserRolesEnum";
import BlogTextFormComponent from "./forms/BlogTextFormComponent";
import Module from "../../models/module/Module";
import Blog from "../../models/blog/Blog";
import ModuleRepository from "../../repository/ModuleRepository";
import BlogContent from "../../models/blog/BlogContent";
import JsonHelper from "../../helpers/JsonHelper";
import { LoaderComponent } from "../basics/layout";
import moment from "moment";

class BlogAddFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            model: this.props.model !== undefined ? this.props.model : new BlogContent(),
            loading: true,
            settings: {},
            isEdit: false,
            roles: this.props.user.roles,
        };

        this.table_ref = React.createRef();

        this.customProps = { ...this.props };
        this.isManager = CheckPermissions.role(this.state.roles, UserRolesEnum.MANAGER) && !CheckPermissions.role(this.state.roles, UserRolesEnum.RESELLER);
    }

    componentDidMount() {
        let promises = [
            ModuleRepository.getSettings()
        ];

        if (this.props.get_promise !== undefined) {
            promises.push(this.props.get_promise);
        }

        Promise.all(promises)
            .then(result => {
                let settingsResult = result[0];
                let settings = {};
                if (settingsResult !== undefined && settingsResult.data !== undefined) {
                    settings = settingsResult.data.settings;
                }

                let model = this.state.model;
                model.published_at = moment().format('YYYY-MM-DD HH:mm:00');
                if (result[1] !== undefined) {
                    model = Blog.fromJson(result[1]);
                    let content = model.contents.filter(content => content.language === this.props.match.params.language)[0];

                    model.title = content.title;
                    model.summary = content.summary;
                    model.value = content.value === '[]' ? {} : JsonHelper.tryParse(content.value);
                    model.seo_title = content.seo_title;
                    model.seo_tags = content.seo_tags ? JsonHelper.tryParse(content.seo_tags) : [];
                    model.seo_description = content.seo_description;
                }

                this.setState({
                    loading: false,
                    settings: settings,
                    model: model,
                    isEdit: model.id
                });
            });
    }

    getBeforeSubmit = (element) => BlogTextFormComponent.fields_image_before_submit(element)

    render() {
        if (this.state.loading) return <LoaderComponent />;

        return (
            <StandardFormComponent
                {...this.customProps}
                ref={this.table_ref}
                parent={this}
                className={"blog"}
                validationSchema={Blog.schema(this.state.settings)}
                model={this.state.model}
                formSubmit={(values, formikActions) => {
                    this.getBeforeSubmit.bind();
                    return this.getBeforeSubmit(this.table_ref.current)
                        .then(() => {
                            if (this.state.isEdit) {
                                return BlogRepository.update({ id: values.id, language: this.props.match.params.language, ...values })
                                    .then(() => {
                                        FormToastComponent.successTrans("Blog", "Default.saved");
                                        this.props.history.push('/module/' + this.props.slug + '/' + Module.getId() + '/overview');
                                    })
                                    .catch(error => FormHelper.handleSubmitError(this, error))
                            } else {
                                return BlogRepository.create(values)
                                    .then(() => {
                                        FormToastComponent.successTrans("Blog", "Default.saved");
                                        this.props.history.push('/module/' + this.props.slug + '/' + Module.getId() + '/overview');
                                    })
                                    .catch(error => FormHelper.handleSubmitError(this, error))
                            }
                        });
                }}
                formErrors={this.state.form_errors}
                fields={BlogTextFormComponent.fields(this.state.settings)}
            />
        );
    }
}

export default withRouter(BlogAddFormComponent);